import { FactureState } from "../hooks/useFacture";

const isEmptyRèglementLine = (règlement: FactureState["règlements"][number]) =>
  règlement.montantCent === 0;

export { isEmptyRèglementLine };
